<template>
    <div class="d-flex justify-space-around">
        <v-card 
            flat
            class="pa-12 mt-12"
            width="100%"
            max-width="210mm"
            min-height="297mm"
        >
            <v-card flat class="d-flex flex-row flex-wrap justify-space-between">
                <table style='width: 100%; margin-top: 0cm; font-family: Raleway, Arial, Helvetica, sans-serif;'>
                    <tr style='height: 4cm'> 
                        <td style='font-family: Roboto, sans-serif; font-size: 32px; color: #35b729; text-align: left; vertical-align: top; margin-bottom: 1cm;'><span>PROYECTO</span><strong>PERU</strong></td> 
                        <td style='font-size: 32px; color: grey; text-align: right; vertical-align: top; margin-top: 5cm;'>  
                            <div>INVOICE</div>  
                            <div style='font-size: 18px;'>  
                                {{getDateFromTimestamp(getApplication(application_id).applied)}}  
                            </div>  
                            <div style='font-size: 12px;'>refnr:   
                                {{ getRefnr(application_id) }}
                            </div>  
                        </td>  
                    </tr>  
                    <tr style='height: 5cm'> 
                        <td style='font-size: 14px; text-align: left; vertical-align: top;'>
                            <span v-if="lead.first_name && lead.last_name">
                                <h3 style='color: grey;'>  {{lead.first_name}} {{lead.last_name}}  </h3>
                            </span>
                            <span v-if="lead.nationalityId">
                                {{getNationalityFromId(lead.nationalityId)}}
                            </span>
                            <span v-if="lead.email">
                                {{lead.email}}
                            </span>
                        </td> 
                        <td style='font-size: 14px; text-align: right; vertical-align: top;'>  
                            <h3 style='color: grey;'>Proyecto Peru Centre S.A.C.</h3> 
                            <div>Avenida Arco Pata 466-A</div> 
                            <div>Cusco, Cusco, 45</div> 
                            <div> 51 84 240 278</div> 
                            <div>info@proyectoperucentre.org</div> 
                        </td> 
                    </tr>  
                </table>
            </v-card>
            <v-card-text class="px-0 px-sm-2 mt-4">
                <v-container fluid 
                    class="d-flex flex-row flex-wrap pa-0"
                >
                    <template>
                        <v-data-table
                            :headers="headers"
                            :items="createTable(application_id)"
                            :items-per-page="20"
                            disable-pagination
                            hide-default-footer
                        ></v-data-table>
                    </template>   
                </v-container>
                <v-divider class="my-5"></v-divider>
                <v-card 
                    v-if="getApplication(application_id)"
                    flat
                    width="100%"
                    class="d-flex flex-column flex-wrap text-right"
                >   
                    <h4 v-if="getApplication(application_id).discountPercentage">
                        {{ getApplication(application_id).discountPercentage }}% discount: - ${{ getApplication(application_id).discount.toFixed(2) }}
                    </h4>
                    <h4 v-else-if="getApplication(application_id).discount">
                        Discount: - ${{ getApplication(application_id).discount.toFixed(2) }}
                    </h4>
                    <h4 v-if="getApplication(application_id).refund">
                        Refund: - ${{ getApplication(application_id).refund.toFixed(2) }}
                    </h4>
                    <span v-if="getApplication(application_id).fixedPrice">Corrected price:</span>
                    <span v-else-if="getServicesApplied(application_id).length === 1">Total price for this service:</span>
                    <span v-else>Total price for {{getServicesApplied(application_id).length}} services:</span>
                    <h2 class="ppc_darkgreen--text">
                        {{getApplication(application_id).totalPrice}} USD
                        <div class="grey--text mb-5 caption">
                            ({{ (getApplication(application_id).totalPrice * getApplication(application_id).exchangeRate).toFixed(0) }} PEN)
                        </div>
                    </h2>
                    <div style='margin-bottom: 0.5cm;' v-if="this.getApplication(application_id).depositTotal > 0 && (this.getApplication(application_id).totalPrice.toFixed(2) - this.getApplication(application_id).depositTotal > 25)">
                        <div>
                            We will need a deposit of ${{this.getApplication(application_id).depositTotal.toFixed(0) }} in order to make all the necessary reservations.
                        </div>
                    </div>
                </v-card>
                <v-card 
                    flat
                    width="100%"
                    class="d-flex flex-column flex-wrap"
                >  
                    <v-card 
                        flat
                        class="px-5"
                        width="100%"
                        max-width="210mm"
                        min-height="297mm"
                    >
                        <span v-html="messageFooter" class="ma-2"></span>
                    </v-card>
                    <div style='margin-top: 0cm; margin-bottom: 2cm; font-family: Raleway, Arial, Helvetica, sans-serif; background-color: #c7d3d1; height: 2px;'>  
                        <div style='margin-top: 10px;'> 
                            <a target=_blank href='https://proyectoperucentre.org/payment-methods.php' style='display: inline'>Payment Methods</a>  
                            <div style='margin: 0 10px 0 10px; display: inline'>-</div> 
                            <a target=_blank href='https://pagolink.niubiz.com.pe/pagoseguro/PROYECTOPERUCENTREDOL/1505549' style='display: inline'>Credit Card Payment</a> 
                            <div style='margin: 0 10px 0 10px; display: inline'>-</div> 
                            <a target=_blank href='https://proyectoperucentre.org/terms-and-conditions.html' style='display: inline'>Terms & Conditions</a><br><br>
                            <div style='font-size:12px'> 
                                <div style='display: inline'>Bank Information:<br></div> 
                                <div style='display: inline'>Banco de Credito del Peru</div> 
                                <div style='margin: 0 10px 0 10px; display: inline'>-</div> 
                                <div style='display: inline'>Avenida El Sol 189, Cusco, Perú</div> 
                                <div style='margin: 0 10px 0 10px; display: inline'>-</div><br> 
                                <div style='display: inline'>Account: 285-2225357-1-49</div> 
                                <div style='margin: 0 10px 0 10px; display: inline'>-</div> 
                                <div style='display: inline'>Swift: BCPLPEPL</div> 
                                <div style='margin: 0 10px 0 10px; display: inline'>-</div> 
                                <div style='display: inline'>ABA: 067015355</div> 
                            </div> 
                        </div> 
                    </div>
                </v-card>
            </v-card-text> 
        </v-card>
    </div>
</template>

<script>
import getDateFromTimestamp from '../mixins/getDateFromTimestamp';
import getServicesApplied from '../mixins/getServicesApplied';
import formattedDate from '../mixins/formattedDate';
import radioGroups_filtered from '../mixins/radioGroups_filtered';
import getApplication from '../mixins/getApplication';
import getNationalityFromId from '../mixins/getNationalityFromId';
import options_filtered_selected from '../mixins/options_filtered_selected';

export default {
    data () {
        return {
            dialog_application: false,
            application_id: null,
            headers: [
                    {
                        text: 'Service',
                        align: 'start',
                        sortable: false,
                        value: 'name',
                        width: 'auto',
                    },
                    { text: 'Duration', value: 'duration', width: '120px'},
                    { text: 'From', value: 'start', width: '120px' },
                    { text: 'Price', value: 'price', width: '100px' },
                ],
            messageFooter: "",
        }
    },
    created() {
        this.application_id = parseInt(this.$route.params.application_id);
        this.messageFooter = "<div style='text-align:center; font-size: 14px;'>- this invoice is valid for 15 days -</div><br><br>" +
                    "<div><strong>Payment Methods:</strong></div><br>" +
                    "<a target=_blank href='https://wise.com' style='display: inline'>1. Pay with Wise paying minimal bank transfer fees (from zero)</a><br><br>" +
                    "<div style='font-size:12px'>" +
                    "<div style='display: inline'><strong>Bank Information for sending USD from an account inside the US:</strong><br></div>" +
                    "<div style='display: inline'>Account holder: Proyecto Peru Centre S.A.C.</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "<div style='display: inline'>Routing number: 084009519</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "<div style='display: inline'>Account number: 9600009597619123</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div></br>" +
                    "<div style='display: inline'>Account type: Checking</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "<div style='display: inline'>Address: 30 W. 26th Street, Sixth Floor, New York NY 10010, United States</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div><br><br>" +
                    "<div style='display: inline'><strong>Bank Information for sending Euros:</strong></br></div>" +
                    "<div style='display: inline'>Account holder: Proyecto Peru Centre S.A.C.</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "<div style='display: inline'>SWIFT/BIC: TRWIBEB1XXX</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "<div style='display: inline'>IBAN: BE41 9674 5027 8410</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div></br>" +
                    "<div style='display: inline'>Account type: Checking</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "<div style='display: inline'>Address: Avenue Louise 54, Room S52, Brussels, 1050, Belgium</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div><br><br>" +
                    "<div style='display: inline'><strong>Bank Information for sending British Pounds from an account inside the UK:</strong></br></div>" +
                    "<div style='display: inline'>Account holder: Proyecto Peru Centre S.A.C.</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "<div style='display: inline'>Sort code: 23-14-70</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "<div style='display: inline'>Account number: 64598776</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div></br>" +
                    "<div style='display: inline'>IBAN: GB34 TRWI 2314 7064 5987 76</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "<div style='display: inline'>Address: 56 Shoreditch High Street, London, E1 6JJ, United Kingdom</div>" +
                    "<div style='margin: 0 10px 0 10px; display: inline'>-</div>" +
                    "</div><br>" +
                    "<a target=_blank href='https://pagolink.niubiz.com.pe/pagoseguro/PROYECTOPERUCENTREDOL/1505549' style='display: inline'>2. Pay with Credit Card through Nubiz (5% bank transfer fees)</a><br><br>" +
                    "<div style='margin-top: 10px;'>" +
                    "<a target=_blank href='https://proyectoperucentre.org/payment-methods.php' style='display: inline'>3. Bank Transfer (>$24 see our payment method page)</a><br><br>" +
                    "<div style='margin-top: 10px;'>" +
                    "<div style='margin-top: 0cm; margin-bottom: 2cm; font-family: Raleway, Arial, Helvetica, sans-serif; background-color: #c7d3d1; height: 2px;'>" + 
                    "<div style='margin-top: 10px;'>" +
                "</div>" +
            "</div>"
    },
    mixins: [getDateFromTimestamp, getServicesApplied, formattedDate, radioGroups_filtered, getApplication, getNationalityFromId, options_filtered_selected],
    computed: {
        lead () {
            return this.$store.getters.lead
        },
        services () {
            return this.$store.getters.services
        },
        applications () {
            return this.$store.getters.applications
        },
    },
    methods: {
        createTable(application_id) {
            let services_filtered = JSON.parse(JSON.stringify(this.services.filter(function(item) {
                return item.application_id === application_id;
            })));
            if (services_filtered.length > 0) {
                let i = 0;
                for (i = 0; i < services_filtered.length; i++) {
                    let j = 0;
                    for (j = 0; j < this.$store.state.radioGroups.length; j++) {
                        if (this.$store.state.radioGroups[j].services_id === services_filtered[i].id) {
                            services_filtered[i].name += ', ' + this.$store.state.radioGroups[j].radio_group_value
                        }
                    }
                }
                for (i = 0; i < services_filtered.length; i++) {
                    let j = 0;
                    for (j = 0; j < this.$store.state.options.length; j++) {
                        if (this.$store.state.options[j].services_id === services_filtered[i].id && this.$store.state.options[j].selected) {
                            services_filtered[i].name += ', ' + this.$store.state.options[j].option_name
                        }
                    }
                }
                let result = services_filtered.map((item) => {
                    return {
                        name: item.name,
                        duration: item.duration + " " + item.duration_text,
                        start: this.formattedDate(item.start, "Noday"),
                        price: item.currency + item.servicePrice,
                    };
                }).sort((a, b) => b.start - a.start);
                return result;
            }
            return []; 
        },
        getRefnr(appId) {
            let refnr = appId.toString()
            return refnr.substr(1,refnr.length-1)
        }
    },
}
</script>

<style>
    .v-card__title {
        color: #35b729;
        word-break: normal !important;
    }
    .v-card__subtitle { padding-top: 0; padding-bottom: 0;}
    .pos_absolute {
        position: absolute;
    }
    /* @media all {
        .page-break	{ display: none; }
    }
    @media print {
        .page-break	{ display: block; page-break-before: always; }
    } */
</style>